/**
 * 匿名コンサルホットライン今後の進め方相談の共通文言
 */
export const hotlineConsultantRequestContactText = {
    /**
     * 項目の名前
     */
    label: {
        condition: () => '希望条件',
        description: () => '相談内容',
        schedule1: () => '第一希望',
        schedule2: () => '第二希望',
        schedule3: () => '第三希望',
        scheduleTitle: () => '相談希望日',
    },
};
